import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { getDetailLabel } from '@/shared/copy/details';

export type CoverageDirectoriesSortKey =
  | 'normalizedPath'
  | 'linesPct'
  | 'functionsPct'
  | 'branchesPct'
  | 'statementsPct'
  | 'latestCapturedAt'
  | 'fileCount';

export const coverageDirectoriesTableDefinition: TableDefinition<
  CoverageDirectoriesSortKey,
  'unused'
> = createTableDefinition({
  title: 'Directories',
  searchAriaLabel: 'Search directories',
  columns: [
    { field: 'directory', label: 'Directory', mandatory: true, defaultVisible: true },
    { field: 'lineCoverage', label: 'Line', defaultVisible: true },
    { field: 'functionCoverage', label: 'Function', defaultVisible: true },
    { field: 'branchCoverage', label: 'Branch', defaultVisible: true },
    { field: 'statementCoverage', label: 'Statement', defaultVisible: true },
    { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
    { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
  ],
  defaultSortKey: 'normalizedPath',
  defaultSortDirection: 'asc',
  sortOptions: [
    { key: 'normalizedPath', label: 'Directory' },
    { key: 'linesPct', label: 'Line' },
    { key: 'functionsPct', label: 'Function' },
    { key: 'branchesPct', label: 'Branch' },
    { key: 'statementsPct', label: 'Statement' },
    { key: 'fileCount', label: 'Files' },
    { key: 'latestCapturedAt', label: 'Latest capture' },
  ],
  sortFieldMap: {
    normalizedPath: 'normalizedPath',
    linesPct: 'linesPct',
    functionsPct: 'functionsPct',
    branchesPct: 'branchesPct',
    statementsPct: 'statementsPct',
    fileCount: 'fileCount',
    latestCapturedAt: 'latestCapturedAt',
  },
  statusOptions: [],
});
